import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center pb-3 mb-8 border-b-2 border-brand-400" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h-6 my-11 rounded-full bg-gray-300 animate-pulse w-1/2" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "text-sm italic mb-6" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "col-span-2 lg:col-span-1 mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "col-span-2 lg:col-span-1 mt-6"
}

import { // api
		Auth
	} from '@/api/Auth'

	import { 
		getMeetingByRecordId
	} from './queries'

	import MeetingDetailsLocation from './components/DetailsLocations.vue' // components
	import AttendeesDetails from './components/Attendees.vue'
	import SoundDetails from './components/SoundDetails.vue'

	import EventBus from '../../events'	// events

	import { // language
		useI18n
	} from 'vue-i18n'

	import { // router
		useRoute,
		useRouter
	} from 'vue-router'

	import { // store
		localesStore
	} from '../../store/locales'
	
	import { 
		store as _userStore
	} from '@/store/user'

	import { // types
		FileMakerRecord,
		FindParameters
	} from '@/types'

	import { // vue
		onBeforeUnmount,
		onMounted,
		ref,
		computed
	} from 'vue'	

	
	const __default__ = { name: 'MeetingDetail' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const route = useRoute()
	const router = useRouter()

	const store = localesStore()
	const userStore = _userStore()

	const {t} = useI18n()
	
	const loading = ref(false)
	const meeting = ref<FileMakerRecord>({} as FileMakerRecord)

	const meetingDetailsBreadcrumb = computed(() => {
		if(meeting.value.fieldData?.["fc_calendar_sample_event__JOBS__jobID::name_bride_groom_display"]) {
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}},
				{label: meeting.value.fieldData?.["fc_calendar_sample_event__JOBS__jobID::name_bride_groom_display"], to: {name: "JobDetails", params: {recordId: meeting.value.fieldData?.zcnJobRecordId}} },
				{label: store.getLabel('412'), to: {name: 'Jobs'}},
				{label: meeting.value.fieldData?.Title, to: {name: 'MeetingDetails', params: {recordId: meeting.value.recordId}}}
			]
		}
		return [
			{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}},
			{label: meeting.value.fieldData?.Title, to: {name: 'MeetingDetails', params: {recordId: meeting.value.recordId}}}
		]
	})

	onMounted(async () => {
		getData()

		EventBus.on('change-language', async () => {
			await getData(true)
		})
	})

	onBeforeUnmount(() => {
		EventBus.off('change-language', null)
	})

	const query = computed(() => {
		const contactId = userStore.user.contactId
		const isStaff = userStore.getContactType === 'Staff'
		const contactIdField = isStaff ? 'fc_calendar_sample_event__ATTENDEES__calendarID::_kf_contacts_id' : '_kf_contacts_id'

		const querySearch = [
			{
				[contactIdField]: contactId,
				recordId: route.params.recordId
			}
		]

		return querySearch
	})

	async function getData(reset: boolean = false) {
		try {
			loading.value = true

			const contactId = userStore.user.contactId
			const sessionId = userStore.user.sessionId
			const scriptParams = JSON.stringify({
				language: store.getFmLanguage,
				sessionId,
				contactId
			})

			let params: FindParameters = {
				query: query.value,
				limit: 1,
				"script.prerequest": "Set Language",
				"script.prerequest.param": scriptParams
			}
			
			// fetch meeting by record id
			let res = await getMeetingByRecordId(params)
			const record = res.response.data[0]
			meeting.value = record
		}
		catch(e: any) {
			console.error(e)

			// redirect if server session expired 
			if(e?.code == "952") {
				await Auth.signOut()
				router.push({name: "Login"})
			}
		}
		finally {
			loading.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_breadcrumb = _resolveComponent("tw-breadcrumb")!
  const _component_collapsable_card = _resolveComponent("collapsable-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tw_breadcrumb, { crumbs: meetingDetailsBreadcrumb.value }, null, 8, ["crumbs"])
    ]),
    _withDirectives(_createElementVNode("div", null, _hoisted_3, 512), [
      [_vShow, loading.value]
    ]),
    _withDirectives(_createElementVNode("h1", { class: "page-title" }, _toDisplayString(meeting.value.fieldData?.Title), 513), [
      [_vShow, !loading.value]
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('meetings.id')) + " " + _toDisplayString(meeting.value.fieldData?._kp_fccalendarevents_id) + " - " + _toDisplayString(meeting.value.fieldData?.status_display), 1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_collapsable_card, {
        title: _unref(t)('meetings.meetingDetailsAndLocation')
      }, {
        default: _withCtx(() => [
          _createVNode(MeetingDetailsLocation, { meeting: meeting.value }, null, 8, ["meeting"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_collapsable_card, {
        title: _unref(store).getLabel('408')
      }, {
        default: _withCtx(() => [
          _createVNode(AttendeesDetails, {
            meeting: meeting.value,
            loading: loading.value,
            breadcrumb: meetingDetailsBreadcrumb.value
          }, null, 8, ["meeting", "loading", "breadcrumb"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    (meeting.value?.fieldData?.Type_display == 'Sound')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_collapsable_card, {
            title: _unref(t)('meetings.musicDetails')
          }, {
            default: _withCtx(() => [
              _createVNode(SoundDetails, { meeting: meeting.value }, null, 8, ["meeting"])
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})